// Public marketing/analytics tag IDs (safe to ship to the client).
export const analytics = {
    metaPixelId: '1524630551308830',
    twitterPixelId: 'ocfg6',
    gaMeasurementId: 'G-8VE60TGHT4'
} as const
